import React from 'react'

import { CircularProgress, Fade } from '@mui/material'

export default React.memo(({ classes }) => (
  <Fade in timeout={500}><div className={classes.loading}><CircularProgress /></div></Fade>
))
